import { EventV2InfoForm } from "./EventV2InfoForm";

export default EventV2InfoForm;
